import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const GuideModal = ({ show, onClose }) => {
    return (
        <Modal show={show} onHide={onClose} size={"xl"}>
            <Modal.Header closeButton>
                <Modal.Title>
                    INSTRUCTIVO PARA CONSULTAR LOS APU EN EL ARCHIVO UNIFICADO
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    El Archivo Unificado corresponde a una herramienta digital
                    en formato Excel que contiene la información de los Análisis
                    de Precios Unitarios Regionalizados de Referencia (APU) para
                    las 140 provincias del territorio nacional.
                </p>

                <h6 className="fw-bold mt-4">1. Descargue el archivo</h6>
                <p>
                    Haga clic en el botón <strong>“Archivo Unificado”</strong>{" "}
                    para descargar la herramienta.
                </p>

                <h6 className="fw-bold mt-4">2. Seleccione su provincia</h6>
                <p>
                    En la pestaña <strong>“Portada”</strong>, seleccione el
                    departamento, la provincia y el factor horario de su
                    interés. El mapa interactivo resaltará automáticamente la
                    provincia seleccionada.
                    <br />
                    <span className="fst-italic">
                        Nota: El factor horario corresponde a la cantidad de
                        horas laboradas en la semana, conforme a la normativa
                        vigente. (Decreto 2101 de 2021)
                    </span>
                </p>

                <h6 className="fw-bold mt-4">3. Navegación por el archivo</h6>
                <p>
                    En la pestaña <strong>“Menú”</strong>, encontrará los
                    siguientes accesos rápidos:
                </p>
                <ul>
                    <li>
                        <strong>Consideraciones de consulta:</strong> Muestra
                        una pestaña con las consideraciones sobre el uso y
                        consulta de los APU regionalizados.
                    </li>
                    <li>
                        <strong>Listado de provincias:</strong> Presenta el
                        listado de provincias junto con su código, altura,
                        temperatura, entre otros datos relevantes.
                    </li>
                    <li>
                        <strong>Equipo:</strong> Contiene el listado de equipos
                        incluidos en los APU, con sus precios actualizados según
                        la provincia seleccionada.
                    </li>
                    <li>
                        <strong>Materiales:</strong> Muestra los materiales que
                        conforman los APU, con sus respectivos precios según la
                        provincia seleccionada.
                    </li>
                    <li>
                        <strong>Transporte:</strong> Presenta los elementos de
                        transporte incluidos en los APU, con su respectivo
                        precio según la provincia seleccionada.
                    </li>
                    <li>
                        <strong>Mano de obra:</strong> Incluye el listado de la
                        mano de obra que integra los APU, con sus precios según
                        la provincia seleccionada.
                    </li>
                </ul>

                <h5 className="fw-bold mt-4">ALTERNATIVAS DE CONSULTA</h5>
                <p>
                    En la pestaña <strong>“Menú”</strong> encontrará dos
                    alternativas de consulta de los APU:
                </p>

                <ol>
                    <li>
                        <strong>Ir a APU Base:</strong> Accede a una pestaña que
                        contiene la totalidad de los APU. Podrá visualizar el
                        APU de su interés seleccionando únicamente el número del
                        ítem correspondiente. El contenido se actualizará
                        automáticamente con la información de la provincia
                        seleccionada.
                    </li>
                    <li>
                        <strong>Índice:</strong> Muestra el listado completo de
                        actividades, que incluye subtotales de equipos,
                        materiales, transporte, mano de obra y el costo directo
                        total. Al hacer clic sobre un ítem, será dirigido a su
                        APU correspondiente.
                    </li>
                </ol>

                <p className="mt-3">
                    <span className="fst-italic">
                        Nota: Al realizar la consulta, asegúrese de que la
                        información corresponde al departamento y la provincia
                        de su interés. En caso contrario, diríjase a la pestaña
                        “Portada” y actualice dicha selección.
                    </span>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Aceptar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GuideModal;
